import {downloadFile} from '@/utils/file-download';

export default {
  data() {
    return {
      formData: {
        showHeader: true,
        showBikeImage: true,
        showSizingSelections: true,
        showPricing: true,
        pdfView: true,
        tidyHTML: true,
      },
    };
  },

  methods: {
    downloadSellSheet() {
      const esc = encodeURIComponent;

      // Object.entires gives you array of arrays eg. [[a,true],[b,false],[c,true]]
      const queryParams = Object.keys(this.formData)
        .map((k) => esc(k) + '=' + esc(this.formData[k]))
        .join('&');

      const requestUrl = `/project-one/sell-sheet/${this.bikeData.code}/pdf?${queryParams}`;

      this.setPageLoading(true);

      downloadFile(requestUrl, `Project_One_Sell_Sheet_${this.bikeData.code}.pdf`, 'application/pdf')
        .then(() => {
          this.$nextTick(() => {
            this.setPageLoading(false);
          });
        })
        .catch((error) => {
          console.error(error);
          this.setPageLoading(false);
          this.$notify({
            type: 'warning',
            message: this.bp('unableToProcess'),
          });
        });
    },
  },
};
